import React, {Component} from 'react';
import {Route, Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import ComponentDictionary from '../ComponentDictionary';
import ChooseClient from '../ChooseClient';
class RoutesComponent extends Component {

    render() {
        if ( window.location.pathname !== '/' && window.location.pathname !== '/uitloggen') {
            return <Redirect to="/" />
        }
        return (
            <div>
                <Route exact path={'/'} component={ChooseClient} />
                <Route exact path={'/uitloggen'} component={ComponentDictionary['Logout']} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.UserReducer,
    }
}


export default withRouter(connect(mapStateToProps)(RoutesComponent));



// WEBPACK FOOTER //
// ./src/components/Application/ChooseClientRoutes/index.js